import React, { useState, useEffect } from "react"
import RangeSlider from "./RangeSlider"
import DoughnutChart from "./Charts/DoughnutChart"
import { Button } from "./Buttons"
import Headings from "./Texts/Headings"
import Paragraphs from "./Texts/Paragraphs"

const EMICalculator = () => {
  const [loanAmount, setLoanAmount] = useState(100000)
  const [interestRate, setInterestRate] = useState(12)
  const [loanTenure, setLoanTenure] = useState(1)
  const [emi, setEMI] = useState(0)
  const [totalInterest, setTotalInterest] = useState(13700)

  useEffect(() => {
    calculateEMI()
  }, [loanAmount, interestRate, loanTenure])

  const calculateEMI = () => {
    const principal = loanAmount
    const rate = interestRate / 12 / 100
    const time = loanTenure * 12
    const emiValue =
      (principal * rate * Math.pow(1 + rate, time)) /
      (Math.pow(1 + rate, time) - 1)
    const totalAmount = emiValue * time
    const interestAmount = totalAmount - principal

    setEMI(Math.round(emiValue))
    setTotalInterest(Math.round(interestAmount))
  }

  const principalPercent = (
    (Number(loanAmount) / (Number(loanAmount) + totalInterest)) *
    100
  ).toFixed(2)
  const intrestPercent = (
    (Number(totalInterest) / (Number(loanAmount) + totalInterest)) *
    100
  ).toFixed(2)

  return (
    <div className="mt-[45px] px-[16px]">
      <Headings
        text="EMI Calculator"
        className="block md:hidden"
      />
      {/* <h1 className="text-[24px]  md:text-[48px] mb-[12px] md:mb-[31px]  text-[#262626] font-filson-soft font-[700] md:font-[500] leading-[24px] md:leading-[37.12px] block md:hidden"
      >
        EMI Calculator
      </h1> */}
      <div className="grid grid-cols-2 md:grid-cols-5 gap-[15px]">
        <div className="col-span-2 md:col-span-2">
          <DoughnutChart
            data={[
              {
                title: "Principal amount",
                value: Math.floor(principalPercent),
                color: "#E53F50",
                amount: loanAmount,
              },
              {
                title: "Interest amount",
                value: Math.floor(intrestPercent),
                color: "#6F4C9F",
                amount: totalInterest,
              },
            ]}
          />
        </div>
        <div className="col-span-2 md:col-span-3">
          <Headings
            text="EMI Calculator"
            className="hidden md:block"
          />
          {/* <h1 className="text-[24px] md:text-[48px] mb-[12px] md:mb-[31px]  text-[#262626] font-filson-soft font-[700] md:font-[500] leading-[24px] md:leading-[37.12px] hidden md:block">
            EMI Calculator
          </h1> */}
          <RangeSlider
            title="Loan Amount"
            subText={`${Math.floor(loanAmount / 100000)} lac`}
            value={loanAmount}
            min={100000}
            max={10000000}
            onChange={setLoanAmount}
            containerClass="mt-[0px]"
          />
          <RangeSlider
            title="Rate of Intrest"
            subText={`${interestRate}%`}
            value={interestRate}
            min={5}
            max={100}
            onChange={setInterestRate}
          />
          <RangeSlider
            title="Loan Tenure"
            subText={`${loanTenure} yr`}
            value={loanTenure}
            min={1}
            max={10}
            onChange={setLoanTenure}
          />
          <div className="flex justify-between items-center mt-[45px]">
            <div>
              <Paragraphs
                variant="tertiary"
                text={" Your monthly EMI Is"}
                className="text-[#424952] text-opacity-50 mb-[8px] md:mb-[20px]"
              />
              <p className="font-filson-soft font-[700] text-[24px] md:text-[28px] lg:text-[32px]  leading-[20px] md:leading-[37.12px] tracking-[-2%] text-[#424952]">
                Rs {emi}
              </p>
            </div>
            <Button title={"Apply"} />
          </div>

        </div>
      </div>
    </div>
  )
}

export default EMICalculator
